import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

import { ModalOfflineComponent } from './modal-offline.component';

@NgModule({
  imports: [IonicModule, CommonModule],
  declarations: [ModalOfflineComponent],
  exports: [ModalOfflineComponent],
})
export class ModalOfflineModule {}
